import { get, destroy, put, } from '.';

export function GetCommunicationResponses(options = {}) {
	return get<any>("/app/api/communication_responses", options);
}

export function DestroyCommunicationResponses(options = {}) {
	return destroy<any>("/app/api/communication_responses", options);
}

export function UpdateCommunicationResponseStatusForMessageUnresponded(options = {}) {
	return put<any>("/app/api/communication_responses", options);
}